import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import * as mobxReact from 'mobx-react';
import { SubWindowsHost } from '../global/sub-window/sub-windows-host';
import EventTrackerList from './_event-tracker-list/event-tracker-list';
import { ManageEventTrackerViewModal } from './manage-event-tracker.viewmodel';


const ManageEventTrackerPresentation = injectIntl(mobxReact.observer((props: { intl: IntlShape; vm: ManageEventTrackerViewModal }) => {
    const { vm, intl } = props;

    const title = (
        intl.formatMessage(
            {
                id: 'oe.common.eventTracker',
                defaultMessage: 'Event Tracker',
                description: 'Section header'
            })
    );

    return (
        <SubWindowsHost>
            <div className='page-container'>
                <section className='top-page-title event-tracker horizontal-row horizontal-row--with-bottom-margin'>
                    <h1 className='text-ellipsis'>{title}</h1>
                </section>
                { vm.getPageVM() && <EventTrackerList key={vm.getPageVM().route} vm={vm.getPageVM()} /> }
            </div>
        </SubWindowsHost>
    );
}));

export { ManageEventTrackerPresentation };
